import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Column {
  label: string;
  value: string;
  checked?: boolean;
}
interface SourceTable {
  value: string;
  label: string;
  checked: boolean;
  selectedColumns: Column[];
  alias?: string;
  allColumns: Column[];
}

interface StreamModel {
  id: any;
  streamType: string
  prevStream: number;
  config: any;
}

interface GeneralSettings {
  name: string;
  description: string;
}

interface ModalState {
  dataSourcePopup: boolean;
  selectedDataSources: any;
  generalSettings: GeneralSettings
  currentlySelectedStream: number;
  isImport?: boolean;
  streams: any,
  isValidationReq?: boolean;
  isStreamInValid?: any;
}

const initialState: ModalState = {
  dataSourcePopup: false,
  selectedDataSources: [],
  generalSettings: { name: "", description: "" },
  currentlySelectedStream: 0,
  isImport: true,
  streams: [],
  // items: [],
  isValidationReq: false,
  isStreamInValid: { join: false, standardization: false, filter: false, incrementalLogic: false, sort: false, derivedColumns: false, encryption: false, masking: false, datatypeValidation: false, union: false, fillNulls: false, deduplication: false, deduplicationMain: false }
};


const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openDatasourceModal: (state) => {
      state.dataSourcePopup = true;
    },
    setPipelineType: (state, action: PayloadAction<any>) => {
      console.log("action", action)
      state.isImport = action.payload;
    },
    closeDatasourceModal: (state) => {
      state.dataSourcePopup = false;
    },
    addGeneralSettings: (state, action: PayloadAction<GeneralSettings>) => {
      state.generalSettings = action.payload;
    },

    addSelectedDatasource: (state, action: PayloadAction<any[]>) => {
      state.selectedDataSources = action.payload;
    },
    checkStreamValidations: (state, action: PayloadAction<any>) => {
      state.isStreamInValid = action.payload;
    },

    appendSelectedDatasource: (state, action: PayloadAction<any>) => {
      const newDataSources = action.payload;
      state.selectedDataSources = {
        ...state.selectedDataSources,
        ...newDataSources,
      };
    },
    addStreams: (state, action: PayloadAction<any[]>) => {
      const newStreams = action.payload.map((connection, index) => ({
        name: `stream${index + 1}`,
        // streamID: connection.id,
        streamID: 100 + index,
        connection_name: connection.connection_name,
        connectionID: connection.id,
        datasource_name: connection.datasource_name,
        label: connection.label,
        exportConnectionID: connection.exportConnectionID,
        type: connection.type,  // Type comes from the payload
        prevStream: connection.prevStream || null,  // PrevStream comes from the payload or null
        config: [],
        title: `Source ${index + 1}`
      }));
      state.streams = [...newStreams];
    },

    addStream: (state, action: PayloadAction<any>) => {
      const prvStreamsIndex = state.streams?.findIndex((item: any) => item.streamID == action.payload.prevStream)
      state.streams.forEach((stream: any) => {
        stream.isActive = false;
      });
      const maxStreamID = Math.max(...state.streams.map((stream: any) => stream.streamID));
      const newStream = {
        name: `stream${state.streams.length + 1}`,
        streamID: 1 + maxStreamID,
        type: action.payload.type,  // Type from the payload
        prevStream: action.payload.prevStream,  // Previous stream ID from the payload
        config: [],  // Empty array for new stream
        title: action.payload?.type === "target" ? "Target" : `Source ${state.streams.length + 1}`,
        connectionID:action.payload.connectionID,
        exportConnectionID:action.payload?.exportConnectionID ? action.payload.exportConnectionID : undefined,
        connection_name: action.payload?.connection_name ? action.payload?.connection_name : undefined,
        datasource_name: action.payload?.datasource_name ? action.payload?.datasource_name : undefined,
        isActive: true,
        sourceTableName: action.payload.sourceTableName ? action.payload.sourceTableName : undefined

      };
      state.streams.splice(prvStreamsIndex + 1, 0, newStream);
      // state.streams.push(newStream);
      const targetIndex = state?.streams?.findIndex((stream: any) => stream.type === "target");
      if (targetIndex != -1) {
        console.log('targetIndex', targetIndex)
        const targetObject = state.streams[targetIndex];
        const expectedStreamIndex = state?.streams?.findLastIndex((item: any) => item.connectionID == targetObject.connectionID);
        state?.streams?.splice(targetIndex, 1)
        state?.streams?.splice(expectedStreamIndex + 1, 0, targetObject)
      }
      state.streams = state.streams.map((stream: any, index: any, array: any) => {
        // If the type is 'datasource', prevStream should be null
        if (stream.type === 'datasource') {
          return { ...stream, prevStream: null };
        } else {
          // Otherwise, set prevStream to the streamID of the previous stream
          const prevStreamID = index > 0 ? array[index - 1].streamID : null;
          return { ...stream, prevStream: prevStreamID };
        }
      });

      const deduplicationStreamIndex = state.streams.findIndex((stream: any) => stream.type === "de_duplication_main");

      // If deduplication stream exists, move it to the last position
      if (deduplicationStreamIndex !== -1) {
        const deduplicationStream = state.streams[deduplicationStreamIndex];
        const targetStream = state.streams?.find((item: any) => item.type == 'target');
        // Modify the deduplication stream if needed (example: changing the title)
        const modifiedStream = {
          ...deduplicationStream,
          prevStreamID: targetStream?.streamID,  // Modify properties as needed
          streamID: targetStream?.streamID + 1,  // Modify properties as needed
        };

        // Remove the deduplication stream from its current position
        state.streams.splice(deduplicationStreamIndex, 1);

        // Push the modified deduplication stream to the last
        state.streams.push(modifiedStream);
      }
      state.currentlySelectedStream = newStream.streamID;
    },
    appendDeduplicationStream: (state, action: PayloadAction<any>) => {
      state.streams.forEach((stream: any) => {
        stream.isActive = false;
      });
      const maxStreamID = Math.max(...state.streams.map((stream: any) => stream.streamID));
      const newStream = {
        name: `stream${state.streams.length + 1}`,
        streamID: 1 + maxStreamID,
        type: action.payload.type,  // Type from the payload
        prevStream: action.payload.prevStream,  // Previous stream ID from the payload
        config: [],  // Empty array for new stream
        connectionID: action.payload.connectionID,
        title: 'Deduplication',
        isActive: true,
        sourceTableName: action.payload.sourceTableName ? action.payload.sourceTableName : undefined

      };
      state.currentlySelectedStream = newStream.streamID;
      state.streams = [...state.streams, ...[newStream]];
    },
    appendStreams: (state, action: PayloadAction<any[]>) => {
      const startIndex = Object.keys(state.selectedDataSources)?.length;
      console.log("actionpayload", action.payload, startIndex)
      const maxStreamID = Math.max(...state.streams.map((stream: any) => stream.streamID));

      const newStreams = action.payload.map((connection, index) => ({
        name: `stream${maxStreamID + index + 1}`,
        streamID: maxStreamID + index + 1,
        type: connection.type,
        prevStream: connection.prevStream,
        config: [],
        connection_name: connection.connection_name,
        connectionID: connection.id,
        datasource_name: connection.datasource_name,
        title: `Source ${Object.keys(state.selectedDataSources)?.findIndex((item: any) => +item == connection.id) + 1}`,
        isActive: false,
      }));
      state.streams = [...state.streams, ...newStreams];
    },

    deleteStream: (state, action: PayloadAction<number>) => {
      // state.streams = state.streams.filter((stream: any) => stream.streamID !== action.payload);

      const streamIDToDelete = action.payload;

      const indexToDelete = state.streams.findIndex((stream: any) => stream.streamID === streamIDToDelete);

      if (indexToDelete === -1) return;

      // const prevStreamOfDeleted = state.streams[indexToDelete].prevStream;

      state.streams = state.streams.filter((stream: any) => stream.streamID !== streamIDToDelete);

      // for (let i = indexToDelete; i < state.streams.length; i++) {
      //   if (state.streams[i].type !== 'datasource') {
      //     state.streams[i].prevStream = prevStreamOfDeleted;
      //   }
      // }
      //   state.streams = state.streams.filter((stream: any, index: any) => {
      //     // Keep all elements before the indexToDelete
      //     if (index < indexToDelete) return true;

      //     // Keep elements after indexToDelete only if their type is 'datasource'
      //     if (index > indexToDelete && stream.type === 'datasource') return true;

      //     // Otherwise, remove the element
      //     return false;
      // });
    },
    addItem: (state, action: PayloadAction<any[]>) => {
      console.log("here")
    },
    isActiveStream: (state, action: PayloadAction<any>) => {

      state.streams = state.streams.map((stream: any) =>
        stream.streamID === action.payload ? { ...stream, isActive: !stream.isActive } : { ...stream, isActive: false }
      );
    },
    removeItem: (state, action: PayloadAction<any>) => {
      console.log("rewmove")
    },
    updateStreamTitle: (state, action: PayloadAction<{ streamID: any; newTitle: string }>) => {

      const { streamID, newTitle } = action.payload;
      console.log("streamIDstreamID", streamID, newTitle, state.streams)
      state.streams = state.streams.map((stream: any) => {
        console.log("streamstreamstreamstream", stream)
        return (
          stream.streamID == streamID ? { ...stream, title: newTitle } : stream
        )
      }

      );
    },
    updateItemSelection: (state, action: PayloadAction<any>) => {
      const { id } = action.payload;
      const updatedDataSources = { ...state.selectedDataSources };
      Object.keys(updatedDataSources).forEach(key => {
        const connection = updatedDataSources[key];
        if (connection.ConnectionID === id) {
          updatedDataSources[key] = { ...connection, isSelected: !connection.isSelected };
        }
      });

      state.selectedDataSources = updatedDataSources;

    },
    // saveSelectedSourceTables: (state, action: PayloadAction<{ id: any; selectedSourceTables: SourceTable[], isActiveStateChangeRequired: boolean }>) => {

    //   const { id, selectedSourceTables, isActiveStateChangeRequired } = action.payload;

    //   state.streams = state.streams.map((stream: any) => ({
    //     ...stream,
    //     isActive: !isActiveStateChangeRequired && stream.streamID === id ? true : false, // Set isActive to false for all streams
    //     config: stream.streamID === id ? selectedSourceTables : stream.config,
    //   }));
    //   if (isActiveStateChangeRequired) {
    //     state.currentlySelectedStream = 0;
    //   } // Set currentlySelectedStream to 0

    // },
    saveSelectedSourceTables: (
      state,
      action: PayloadAction<{
        id: any;
        selectedSourceTables: SourceTable[];
        lakehouseconfigdata?: any[] | null;
        isActiveStateChangeRequired: boolean;
      }>
    ) => {
      const { id, selectedSourceTables, isActiveStateChangeRequired, lakehouseconfigdata } = action.payload;
    
      state.streams = state.streams.map((stream: any) => {
        const updatedStream = {
          ...stream,
          isActive: !isActiveStateChangeRequired && stream.streamID === id ? true : false, // Set isActive to false for all streams
          config: stream.streamID === id ? selectedSourceTables : stream.config,
        };
    
        // Add lakehouseconfigdata only if it is provided
        if (stream.streamID === id && lakehouseconfigdata) {
          updatedStream.lakehouseconfigdata = lakehouseconfigdata;
        } else {
          updatedStream.lakehouseconfigdata = null; // Ensure lakehouseconfigdata is null if not provided
        }
    
        return updatedStream;
      });
    
      if (isActiveStateChangeRequired) {
        state.currentlySelectedStream = 0; // Set currentlySelectedStream to 0
      }
    },
    saveStreamConfigs: (state, action: PayloadAction<{ id: any; data: any[]; label?: any }>) => {

      const { id, data, label } = action.payload;

      state.streams = state.streams.map((stream: any) => ({
        ...stream,
        isActive: stream.streamID === id && label === "target",// Set isActive to false for all streams
        config: stream.streamID === id ? data : stream.config,
      }));

      if (label !== "target") {
        state.currentlySelectedStream = 0; // Set currentlySelectedStream to 0
      }

    },
    saveMappingConfig: (state, action: PayloadAction<{ id: any; data: any; label?: any }>) => {
      const { id, data, label } = action.payload;

      state.streams = state.streams.map((stream: any) => {
        if (stream.streamID === id) {
          return {
            ...stream,
            isActive: false,
            config: [
              {
                ...stream.config?.[0],
                outputStreamName: stream.config?.[0]?.outputStreamName ?? '',
                mapping: data,
              }
            ],
          };
        }
        return stream;
      });

      // state.currentlySelectedStream = 0;
    },

    // saveMappingConfig: (state, action: PayloadAction<{ id: any; data: any; label?: any }>) => {
    //   const { id, data } = action.payload;

    //   state.streams = state.streams.map((stream: any) => {
    //     if (stream.streamID === id) {
    //       const updatedConfig = stream?.config.map((configItem: any) => {
    //         if (configItem.hasOwnProperty('mapping')) {
    //           return { ...configItem, mapping: data };
    //         }
    //         return configItem;
    //       });

    //       return {
    //         ...stream,
    //         isActive: false,
    //         config: updatedConfig,
    //       };
    //     }

    //     return stream;
    //   });

    //   state.currentlySelectedStream = 0;
    // },


    setSelectedStream: (state, action: PayloadAction<any>) => {
      if (state.currentlySelectedStream !== 0) {
        state.currentlySelectedStream = 0;
      } else {
        state.currentlySelectedStream = action.payload;
      }
    },

    saveJoinConfig: (state, action: PayloadAction<{ dataSourceId: any, values: any }>) => {
      // const { dataSourceId, values } = action.payload;
    },
    setSelectedAndActiveStream: (state, action: PayloadAction<number>) => {
      const streamId = action.payload;
      let isActiveFound = false;

      state.streams = state.streams.map((stream: any) => {
        if (stream.streamID === streamId) {
          isActiveFound = !stream.isActive;
          return { ...stream, isActive: !stream.isActive };
        } else {
          return { ...stream, isActive: false };
        }
      });

      state.currentlySelectedStream = isActiveFound ? streamId : 0;
    },
    deactivateAllStreams: (state) => {
      state.streams = state.streams?.map((stream: any) => ({
        ...stream,
        isActive: false,
      }));
      state.currentlySelectedStream = 0;
    },

    setActiveConfig: (state, action: PayloadAction<{ streamID: number, configValue: string }>) => {
      const { streamID, configValue } = action.payload;
      console.log(state.streams)
      state.streams = state?.streams?.map((stream: any) => {
        if (stream?.streamID === streamID) {
          stream.config = stream?.config?.map((cfg: any) => ({
            ...cfg,
            isActive: cfg.value === configValue,
          }));
        } else {
          stream.config = stream?.config?.map((cfg: any) => ({
            ...cfg,
            isActive: false,
          }));
        }
        return stream;
      });
    },
    resetState: (state) => {
      return initialState;
    },
    exportResetState: (state) => {
      return {
        ...initialState, // Reset everything to initial state
        isImport: state.isImport, // Preserve isImport
        selectedDataSources: state.selectedDataSources, // Preserve selectedDataSources
        streams: state.streams.length > 0
          ? [{ ...state.streams[0], config: [] }] // Keep only the first stream and empty its config
          : [], // If streams is empty, set it to an empty array
      };
    },
    deleteStreamByConnectionID: (state, action: PayloadAction<number>) => {
      const connectionIDToDelete = action.payload;
      state.streams = state.streams.filter((stream: any) => stream.connectionID !== connectionIDToDelete);
    },
    validationOnStreamReq: (state, action: PayloadAction<any>) => {
      state.isValidationReq = action.payload
    },
    updateStreams: (state, action: PayloadAction<any>) => {
      state.streams = action.payload
    },
    patchPipelineData: (state, action: PayloadAction<any>) => {
      state.dataSourcePopup = action?.payload?.dataSourcePopup;
      state.selectedDataSources = action?.payload?.selectedDataSources;
      state.generalSettings = action?.payload?.generalSettings;
      state.currentlySelectedStream = action?.payload?.currentlySelectedStream;
      state.isValidationReq = action?.payload?.isValidationReq;
      state.streams = action?.payload?.streams;
      state.isImport = action?.payload?.isImport;
    },
  },
});

export const { openDatasourceModal,
  closeDatasourceModal,
  addGeneralSettings,
  addSelectedDatasource,
  setSelectedStream,
  addItem,
  addStream,
  appendStreams,
  updateItemSelection,
  saveSelectedSourceTables,
  addStreams,
  saveStreamConfigs,
  deleteStream,
  isActiveStream,
  deactivateAllStreams,
  setSelectedAndActiveStream,
  updateStreamTitle,
  saveMappingConfig,
  appendSelectedDatasource,
  setActiveConfig,
  resetState,
  exportResetState,
  setPipelineType,
  deleteStreamByConnectionID,
  validationOnStreamReq,
  updateStreams,
  patchPipelineData,
  appendDeduplicationStream,
  checkStreamValidations,
} = modalSlice.actions;
export default modalSlice.reducer;
